const { Type } = require('@sinclair/typebox');
const Blockly = require('blockly');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');

const TOOLTIP =
    'A Toggle filter based on a property matching either the first or second value. The neutral option is used to clear the filter.';

/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);
    blocklyBlock.setInputsInline(true);

    line1OfInputs
        .appendField('  Property Name:')
        .appendField(new Blockly.FieldTextInput('title'), 'propertyName')
        .appendField('  Negative (false) Option:')
        .appendField(new Blockly.FieldTextInput(''), 'toggleOption1')
        .appendField('  Positive (true) Option:')
        .appendField(new Blockly.FieldTextInput('true'), 'toggleOption2')

        /**
         * Making the neutral option a string makes for an easy way for us to filter and match toggle values if the neutral option is set.
         * Instead of writing a bunch of logic to handle the neutral option as a boolean, we can just filter and match the string value of the neutral option.
         * This allows us to handle the toggle state and set default filters on useSearchElement, all using the same neutral option string.
         * @see https://sstdev.visualstudio.com/DefaultCollection/Backbone/_git/silo_ui/?path=/lib_ui-components/src/hooks/useToggle.js
         * @see https://sstdev.visualstudio.com/DefaultCollection/Backbone/_git/silo_ui/?path=/lib_ui-components/src/searchElements/Toggle.js
         */
        .appendField('  Neutral Option:')
        .appendField(new Blockly.FieldTextInput('neutral'), 'neutralOption')

        /**
         * If a field is undefined, it's excluded from results for both true and false.
         * Checking this checkbox will cause undefined to be treated as false
         */
        .appendField('  Include undefined as false')
        .appendField(new Blockly.FieldCheckbox(), 'includeUndefinedAsFalse');
}

/**
 * @param {{[key: string]: any}} code
 * @param {import('blockly').Block} blocklyBlock
 * @return {{[key: string]: any}}
 */
function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    const propertyName = blocklyBlock.getFieldValue('propertyName');
    const opt1 = blocklyBlock.getFieldValue('toggleOption1');
    const opt2 = blocklyBlock.getFieldValue('toggleOption2');
    const neutralOption = blocklyBlock.getFieldValue('neutralOption');
    const includeUndefinedAsFalse = blocklyBlock.getFieldValue('includeUndefinedAsFalse');
    addCodeProperties([
        { key: 'propertyName', handler: () => propertyName },
        { key: 'toggleValues', handler: () => [opt1, opt2] },
        { key: 'neutralOption', handler: () => neutralOption },
        { key: 'includeUndefinedAsFalse', handler: () => includeUndefinedAsFalse === 'TRUE' }
    ]);
    return code;
}

/** Builds the data dictionary fragment for the ToggleSearch search element. */
function asDataDictionary(hNode, context) {
    const { id, title, propertyName, toggleValues, neutralOption, includeUndefinedAsFalse } = hNode;
    const subDataDictionary = {};

    // Create TypeBox boolean schema with toggle-specific metadata
    const booleanSchema = Type.Boolean({
        'x-id': id,
        title: title,
        'x-dataType': 'boolean',
        'x-propertyName': propertyName,
        'x-toggleValues': toggleValues,
        'x-neutralOption': neutralOption,
        'x-includeUndefinedAsFalse': includeUndefinedAsFalse
    });

    const partialTypeDefinition = {
        [propertyName]: booleanSchema
    };

    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary };
